<template>
  <form class="clientForm grid-12" onsubmit="return false" @submit="send">
    <h3>Dados da Empresa</h3>
    <div class="row wrap justify-around align-center column-s">
      <div class="column grid-2 grid-12-s">
        <label>CNPJ</label>
        <input type="text" v-model="form.cnpj" v-mask="'##.###.###/####-##'" required />
      </div>
      <div class="column grid-3 grid-12-s">
        <label>Razão Social</label>
        <input v-model="form.razao_social" placeholder="Rg, Emissor, Estado" required />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Nome Fantasia</label>
        <input v-model="form.nome_fantasia" placeholder="Nome" required />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Base de custo</label>
        <select v-model="form.id_base_custo" required>
          <option v-for="(base, j) of basisCost" :value="base.id" :key="'bc' + j">
            {{ base.nome }}
          </option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Código Cliente Obrigatório</label>
        <select v-model="form.cod_chamado_cli_obrigatorio" required>
          <option value="false">Não</option>
          <option value="true">Sim</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Tamanho</label>
        <select type="text" v-model="form.tipo_cliente" required>
          <option value>Selecione</option>
          <option value="pequeno">Pequeno</option>
          <option value="grande">Grande</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Tipo de faturamento</label>
        <select type="text" v-model="form.tipo_faturamento" required>
          <option value>Selecione</option>
          <option value="fixo">Fixo</option>
          <option value="variavel">Variável</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Valor Faturamento Fixo</label>
        <Money v-if="form.tipo_faturamento == 'fixo'" v-model="form.valor_faturamento_fixo" placeholder="0,00"
          v-bind="money" required />
        <div v-else style="margin-top: 18px"> R$ 0,00</div>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Frequência</label>
        <select type="text" v-model="form.frequencia" required>
          <option value>Selecione</option>
          <option value="pontual">Pontual</option>
          <option value="recorrente">Recorrente</option>
        </select>
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Franquia de Deslocamento</label>
        <input v-model="form.franquia_deslocamento" type="number" required />
      </div>
    </div>
    <h3>Responsável</h3>
    <div class="row column-s grid-12">
      <div class="column grid-3 grid-12-s">
        <label>Nome</label>
        <input v-model="form.nome" placeholder="Nome" required />
      </div>
      <div class="column grid-3 grid-12-s">
        <label>E-mail</label>
        <input type="text" v-model="form.email" placeholder="E-mail" required />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Celular</label>
        <input v-model="form.celular" placeholder="Celular" v-mask="'(##) #####-####'" required />
      </div>
    </div>
    <h3>Endereço</h3>
    <div class="row grid-12 wrap column-s">
      <div class="column grid-2 grid-12-s">
        <label>CEP</label>
        <input v-model="form.cep" placeholder="CEP" v-mask="'##.###-###'" @input="cep" required />
      </div>
      <div class="column grid-3 grid-12-s">
        <label>Logradouro</label>
        <input v-model="form.logradouro" placeholder="Logradouro" required />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Número</label>
        <input v-model="form.numero" placeholder="Número" required />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Complemento</label>
        <input v-model="form.complemento" placeholder="Complemento" />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Bairro</label>
        <input v-model="form.bairro" placeholder="Bairro" />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>Cidade</label>
        <input v-model="form.cidade" placeholder="Cidade" />
      </div>
      <div class="column grid-2 grid-12-s">
        <label>UF</label>
        <input v-model="form.estado" placeholder="UF" />
      </div>
    </div>
    <h3>Gestor de Demanda Preferencial</h3>
    <div class="row grid-12 wrap column-s justify-around" style="font-size: 14px">
      <div v-for="(gd, i) of gds" :key="'gd' + i" class="gd row align-center">
        <input type="checkbox" @click="() => preferencial(gd.id)"
          :checked="form.gds_preferenciais && form.gds_preferenciais.includes(gd.id) && true" />{{ gd.nome }}
      </div>
    </div>
    <div class="grid-12 row column-s" style="margin-top: 25px">
      <div class="grid-6 grid-12-s row wrap justify-space">
        <h3 class="grid-12">Controle Usuários</h3>
        <div class="grid-3">
          <label>Cadastro Agregados</label>
          <Turnkey
            :data="{ show: true, on: form.cadastro_agregado, toggle: () => form.cadastro_agregado = !form.cadastro_agregado }" />
        </div>
        <div class="grid-3">
          <label>Quantidade Agregados</label>
          <input type="number" v-model="form.limite_cadastro_agregado" min="0" placeholder="0" />
        </div>
        <div class="grid-3">
          <label>Cadastro Usuários</label>
          <Turnkey
            :data="{ show: true, on: form.cadastro_usuario, toggle: () => form.cadastro_usuario = !form.cadastro_usuario }" />
        </div>
        <div class="grid-3">
          <label>Quantidade Usuários</label>
          <input type="number" v-model="form.limite_cadastro_usuario" min="0" placeholder="0" />
        </div>
      </div>
      <div class="grid-6 grid-12-s row wrap justify-center">
        <h3 class="grid-12">White Label</h3>
        <div class="grid-3">
          <label>White Label</label>
          <Turnkey :data="{ show: true, on: form.white_label, toggle: () => form.white_label = !form.white_label }" />
        </div>
        <div class="grid-3">
          <label>Identificador White Label </label>
          <input v-model="form.identificador_white_label" placeholder="Identificador" />
        </div>
      </div>
    </div>

    <div class="grid-12 row column-s" style="margin-top: 25px">
      <div class="grid-6 grid-12-s row wrap justify-space">
        <h3 class="grid-12">Pesquisa de Avaliação/Satisfação do Atendimento</h3>
        <div class="grid-3">
          <label>Usuário Responsável</label>
          <Turnkey
            :data="{ show: true, on: form.usuario_responsavel, toggle: () => form.usuario_responsavel = !form.usuario_responsavel }" />
        </div>
        <div class="grid-3">
          <label>Usuário Cliente</label>
          <Turnkey
            :data="{ show: true, on: form.usuario_cliente, toggle: () => form.usuario_cliente = !form.usuario_cliente }" />
        </div>
        <div class="grid-3">
          <label>Cliente do Cliente</label>
          <Turnkey
            :data="{ show: true, on: form.cliente_cliente, toggle: () => form.cliente_cliente = !form.cliente_cliente }" />
        </div>
      </div>
      <div class="grid-6 grid-12-s row wrap justify-center">
        <h3 class="grid-12">Opções de validação</h3>
        <div class="grid-3">
          <label>Validação Automática</label>
          <Turnkey
            :data="{ show: true, on: form.validacao_automatica, toggle: () => form.validacao_automatica = !form.validacao_automatica }" />
        </div>
        <div class="grid-3">
          <label>Requer Anexo</label>
          <Turnkey
            :data="{ show: true, on: form.requer_anexo, toggle: () => form.requer_anexo = !form.requer_anexo }" />
        </div>
      </div>
    </div>

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-6 grid-12-s">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-6 grid-12-s" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>
    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"><i class="fa fa-edit" />{{ client ? "ATUALIZAR" :
        "ADICIONAR" }}</Button>&nbsp;&nbsp;&nbsp;
      <Button v-if="!form.new && form.status == 'ativo'" type="button" @click="del" :loader="loader" layout="red-go"><i
          class="fa fa-trash" /> DESATIVAR</Button>
      <Button v-if="!form.new && form.status == 'inativo'" type="button" @click="updateStatus" :loader="loader"
        layout="green-go white"><i class="fa fa-check" /> ATIVAR</Button>
    </div>
    <template v-if="client">
      <h3>Permissões</h3>
      <div class="grid-12">
        <div class="title">Operação cliente <Button type="button" :layout="showOperacao ? 'red-go' : 'green-go'"
            title="NOVA OPERAÇÃO" @click="showOperacao = !showOperacao">{{ showOperacao ? "x" : "+" }}</Button></div>
        <OperacaoForm v-if="showOperacao" :reload="loadOperacao" :client="client.id" style="margin: 12px 0" />
        <div class="head row grid-12">
          <div class="grid-6">Operações</div>
          <div class="grid-4">Status</div>
          <div class="grid-2"></div>
        </div>
        <div class="container">
          <template v-for="(o, i) of operacao.list">
            <div class="line row" :key="'operacao-' + i" @click="operacao.show[i] = !operacao.show[i]; operacao = { ...operacao }">
              <div class="grid-6">{{ o.nome }}</div>
              <div :class="'grid-4 ' + o.status">{{ o.status }}</div>
              <div class="grid-2"></div>
            </div>
            <div v-if="operacao.show[i]" :key="'operacao-form-' + i" class="grid-12">
              <OperacaoForm :operacao="o" :reload="loadOperacao" :client="client.id" />
            </div>
          </template>
        </div>
      </div>
      <div class="grid-12" style="margin:30px 0">
        <div class="title">Usuário cliente <Button type="button" :layout="showUsuario ? 'red-go' : 'green-go'"
            title="NOVO USUÁRIO" @click="showUsuario = !showUsuario">{{
              showUsuario ? "x" : "+" }}</Button></div>
        <UsuarioForm v-if="showUsuario" :operacoes="operacao.list" :reload="loadUsuario" :client="client.id"
          style="margin: 12px 0" />
        <div class="head row grid-12">
          <div class="grid-4">Usuários</div>
          <div class="grid-2">Status</div>
          <div class="grid-4">Operação</div>
          <div class="grid-2"></div>
        </div>
        <div class="container">
          <template v-for="(o, i) of usuarios.list">
            <div class="line row" :key="'usuario-' + i" @click="usuarios.show[i] = !usuarios.show[i]; usuarios = { ...usuarios }">
              <div class="grid-4">{{ o.nome }}</div>
              <div :class="'grid-2 ' + o.status">{{ o.status }}</div>
              <div class="grid-4">{{ o.nome_operacao }}</div>
              <div class="grid-2"></div>
            </div>
            <div v-if="usuarios.show[i]" :key="'usuario-form-' + i" class="grid-12">
              <UsuarioForm :usuario="o" :operacoes="operacao.list" :reload="loadUsuario" :client="client.id" />
            </div>
          </template>
        </div>
      </div>

      <h3 class="grid-12">Cidades de Atendimento</h3>
      <div class="row column-s grid-12 align-end" style="margin-bottom: 30px;">
        <div class="grid-2 grid-6-s">
          <label>Estado</label>
          <select v-model="uf" @change="loadCity">
            <option value="">Selecione</option>
            <option v-for="uf in estados" :value="uf.sigla" :key="uf.sigla">{{ uf.nome }}</option>
          </select>
        </div>
        <div v-if="cidades.length" class="grid-2 grid-6-s">
          <label>Cidade</label>
          <select v-model="cidade">
            <option value="">Selecione</option>
            <option v-for="c in cidades" :value="c.id" :key="c.id">{{ c.cidade }}</option>
          </select>
        </div>
        <Button v-if="cidade" @click="addCity" :loader="btLoader" layout="green-go">+ ADICIONAR</Button>
      </div>
      <div class="row wrap grid-12 align-center" style="margin-top: 10px;">
        <div class="tag" v-for="c of cidade_cliente" :key="c.cidade_uf" @click="removeCity(c)" title="REMOVER CIDADE">{{
          c.cidade_uf }}
          <i class="fa fa-trash" />
        </div>
      </div>
    </template>
  </form>
</template>

<script>
import Vue from "vue";
import format from '@/utils/format'
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Turnkey from "@/components/Turnkey.vue";
import OperacaoForm from "@/views/admin/components/OperacaoForm.vue";
import UsuarioForm from "@/views/admin/components/UsuarioForm.vue";
import { Money } from "v-money";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import estados from '../../../../public/json/cidades.json'

export default {
  name: "ClientForm",
  components: { Button, Turnkey, Money, OperacaoForm, UsuarioForm },
  props: { client: Object, reload: Function },
  data() {
    return {
      estados: estados,
      loader: false,
      form: { tipo_pessoa: 'juridica', complemento: '', cpf: "", fone: "", valor_faturamento_fixo: 0, valor_km_adicional: "0", limite_cadastro_agregado: 0, limite_cadastro_usuario: 0, identificador_white_label: false, white_label: false, cadastro_agregado: false, cadastro_usuario: false, usuario_responsavel: false, cliente_cliente: false, usuario_cliente: false, requer_anexo: false, validacao_automatica: false },
      basisCost: [],
      gds: [],
      operacao: { form: {}, list: [], show: {} },
      usuarios: { form: {}, list: [], show: {} },
      whitelabel: {},
      showOperacao: false,
      showUsuario: false,
      uf: '',
      cidade: '',
      cidades: [],
      cidade_cliente: [],
      btLoader: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    ...mapActions("admin", ["CLIENT_CITIES_DEL", "CLIENT_CITIES_ADD", "CLIENT_CITIES", "CLIENT_USUARIO_LIST", "CLIENT_OPERACAO_LIST", "BASISCOST_LIST", "FUNCIONARIO_LIST", "CLIENT_POST", "CLIENT_PUT", "CLIENT_DEL", "CLIENT_ACTIVATE"]),
    ...mapActions("user", ["GET_BANK", "PUT_BANK"]),
    ...mapActions("general", ["LOAD_BANK", "LOAD_CEP", "LOAD_CITIES"]),
    preferencial(ID) {
      if (!Array.isArray(this.form.gds_preferenciais)) this.form.gds_preferenciais = []
      let e = this.form.gds_preferenciais.filter(g => g == ID)
      if (e.length) this.form.gds_preferenciais = this.form.gds_preferenciais.filter(g => g != ID)
      else this.form.gds_preferenciais.push(ID)
    },
    cep() {
      if (this.form.cep.length > 9)
        this.LOAD_CEP(this.form.cep.replace(".", "").replace("-", "")).then((r) => {
          if (r.logradouro) {
            this.form.logradouro = r.logradouro;
            this.form.bairro = r.bairro;
            this.form.cidade = r.localidade;
            this.form.estado = r.uf;
            this.form = { ...this.form }
          }
        });
    },
    loadCity() {
      this.LOAD_CITIES({ estado: this.uf }).then(({ data }) => this.cidades = data || [])
    },
    async addCity() {
      this.btLoader = true
      await this.CLIENT_CITIES_ADD({ id_cidade: this.cidade, id_cliente: this.client.id })
      await this.loadCidades()
      this.btLoader = false
    },
    async removeCity(city) {
      if (confirm(`Deseja remover o atendimento da cidade de ${city.cidade_uf}?`)) {
        await this.CLIENT_CITIES_DEL(city.id)
        await this.loadCidades()
      }
    },
    async send() {
      this.loader = true;
      let data = { ...this.form }
      data.cnpj = format.clear(data.cnpj)
      data.celular = format.clear(data.celular)
      data.cep = format.clear(data.cep)
      data.fone = data.celular
      if (data.gds_preferenciais && data.gds_preferenciais[0] && !data.gds_preferenciais[0].id_gestor) {
        data.gds_preferenciais = []
        this.form.gds_preferenciais.map(id => data.gds_preferenciais.push({ id_gestor: id }))
      }
      let r = await this[this.client ? 'CLIENT_PUT' : 'CLIENT_POST'](data);
      this.loader = false;
      if (r) this.reload()
    },
    async updateStatus() {
      this.loader = true;
      await this.CLIENT_ACTIVATE(this.form.id)
      this.loader = false;
      this.reload()
    },
    async del() {
      if (confirm(`Deseja desativar o Cliente ${this.form.nome}?`)) {
        this.loader = true;
        await this.CLIENT_DEL(this.form.id)
        this.loader = false
        this.reload()
      }
    },
    loadOperacao() { this.showOperacao = false; this.CLIENT_OPERACAO_LIST(this.client.id).then(({ data }) => this.operacao.list = data || []) },
    loadUsuario() { this.showUsuario = false; this.CLIENT_USUARIO_LIST(this.client.id).then(({ data }) => this.usuarios.list = data || []) },
    loadCidades() { this.CLIENT_CITIES({ id_cliente: this.client.id }).then(({ data }) => this.cidade_cliente = data || []) }
  },
  beforeMount() {
    if (this.client) {
      this.form = this.client
      this.loadOperacao()
      this.loadUsuario()
      this.loadCidades()
    }
    this.BASISCOST_LIST().then(({ data }) => (this.basisCost = data || []));
    this.FUNCIONARIO_LIST({ lista_grupo: ["Gestor de Demanda", "Gestor de Registro", "Gestor de Associação", "Gestor de Device", "Gestor de Infra"], status: "ativo", nucleo_abertura: false }).then(({ data }) => (this.gds = data || []));
  }
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.clientForm
  @include form
  padding: 2%
  width: 95%
  .turnkey
    margin-top:10px
  input[type="checkbox"]
    width: 20px
    height: 20px
    margin-right: 10px
  h3
    font-size: 18px
    background: rgba($purple,.8)
    color: white
    padding: 4px
  select
    width: 93%
    max-width: 93%
  .title
    color: $purple
    font-size: 20px
    font-weight: bold
    text-transform: uppercase
    button
      width: 25px
      height: 28px
      padding-top: 4px
  .head
    color: $blue-2
    font-size: 15px
    font-weight: bold
    margin: 4px 0
    padding: 4px
  .container
    @include border
    border-radius: 12px
    overflow-x: hidden
  .line
    padding: 10px
    &:nth-child(even)
      background: #f6f6f6
    &:hover
      background: rgba($blue-1, .1)
      cursor: pointer
    .ativo
      color: $green-2
    .inativo
      color: $red
  .gd
    margin-bottom: 15px
  .tag
    @include border
    padding: 8px 12px
    border-radius: 6px
    margin: 6px 8px
    &:hover
      color: $red
      cursor: pointer
    i
      margin-left: 4px
</style>
